import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllVisaTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VisaType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVisaTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VisaType}?CompanyCode=${companyCode}&Code=${code}` // 
  );
  return data;
};

const insertVisaType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.VisaType, input);
  return data;
};

const updateVisaType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.VisaType, input);
  return data;
};

const deleteVisaType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VisaType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetVisaTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VisaType],
    queryFn: () => getAllVisaTypes(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetVisaTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VisaType],
    queryFn: () => getVisaTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVisaTypeMutation = () => {
  return useMutation({
    mutationFn: insertVisaType,
  });
};

export const useUpdateVisaTypeMutation = () => {
  return useMutation({
    mutationFn: updateVisaType,
  });
};

export const useDeleteVisaTypeMutation = () => {
  return useMutation({
    mutationFn: deleteVisaType,
  });
};
